import React from "react";
import { ArrowUpRightIcon, ShieldCheckIcon } from "lucide-react";
export function Transparency() {
  return <section aria-labelledby="transparence-title" className="bg-white pb-24 lg:pb-32" data-id="element-154" data-mp="2ds6lb8h7rkii">
      <div className="mx-auto max-w-7xl px-6 sm:px-8" data-id="element-155" data-mp="2sonvhwdo2t3h">
        <div className="grid gap-10 rounded-2xl bg-sand p-8 sm:p-12 lg:grid-cols-12 lg:items-center lg:p-16" data-id="element-156" data-mp="2smb6iz9hrigx">
          <div className="lg:col-span-1" data-id="element-157" data-mp="31p2id06a4g93">
            <span className="flex h-14 w-14 items-center justify-center rounded-full bg-ink text-white" data-id="element-158" data-mp="31o0vlyfwi5bj">
              <ShieldCheckIcon className="h-6 w-6" data-id="element-159" data-mp="2wp7r2vildoni" />
            </span>
          </div>
          <div className="lg:col-span-7" data-id="element-160" data-mp="3bf5br1hbbw7y">
            <h2 id="transparence-title" className="font-display text-3xl font-semibold leading-tight text-ink sm:text-4xl" data-id="element-161" data-mp="3bgyggb8d86db">
              Une représentation d'intérêts transparente.
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-162" data-mp="3kdh8zmcops9d">
              L'activité d'Éléonore Para est inscrite au répertoire des représentants d'intérêts tenu par
              la HATVP. Elle respecte les règles déontologiques qui encadrent les échanges avec les
              responsables publics.
            </p>
          </div>
          <div className="lg:col-span-4 lg:text-right" data-id="element-163" data-mp="3luqno9anffa0">
            <a href="https://www.hatvp.fr/le-repertoire/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-ink px-6 py-3.5 text-[15px] font-medium text-white transition-colors duration-150 hover:bg-ink-soft" data-id="element-164" data-mp="3lxcv88xjhus8">
              Consulter le répertoire HATVP
              <ArrowUpRightIcon className="h-4 w-4" data-id="element-165" data-mp="8h5gf3resnqc" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}